import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: (failureCount, error) => {
        // Don't retry client errors (4xx) - request is fundamentally invalid
        const status = error?.response?.status;
        if (status >= 400 && status < 500) return false;
        // Retry up to 3 times for server errors (5xx) and network issues
        return failureCount < 3;
      },
    },
  },
});
